import request from '@/_util/require';

let version = 'v1';
const basePath = `/${version}/waper/erp/pc/ai/session`;

/**
 * 分页查询AI会话列表
 * @param {Object} data - { empId, page: { pageNo, pageSize, sortFields }, sessionName }
 */
export async function getAiSessionPage(data) {
  return request(`${basePath}/getaisessionpage`, {
    method: 'POST',
    data,
  });
}

/**
 * 查询AI会话详情（包含对话项和输出项）
 * @param {Object} params - { sessionId }
 */
export async function getAiSessionDetail(params) {
  return request(`${basePath}/getaisessiondetail`, {
    method: 'GET',
    params,
  });
}

/**
 * 新增生成
 * @param {Object} data - { empId, genType(1-图片2-视频), promptSetting(JSON字符串), sessionId(可为空) }
 */
export async function addAiSessionItem(data) {
  return request(`${basePath}/addaisessionitem`, {
    method: 'POST',
    data,
  });
}

/**
 * 刷新生成项
 * @param {Object} params - { itemId }
 */
export async function refreshAiSessionItem(params) {
  return request(`${basePath}/refreshaisessionitem`, {
    method: 'GET',
    params,
  });
}

/**
 * 删除AI会话
 * @param {Object} params - { sessionId }
 */
export async function deleteAiSession(params) {
  return request(`${basePath}/deleteaisession`, {
    method: 'GET',
    params,
  });
}

/**
 * 修改AI会话(改名/置顶)
 * @param {Object} data - { sessionId, sessionName, isTop, empId 等 }
 */
export async function updateAiSession(data) {
  return request(`${basePath}/updateaisession`, {
    method: 'POST',
    data,
  });
}

/**
 * 查询当前员工Token配额及使用情况
 */
export async function getCurrentQuota() {
  return request(`/${version}/waper/erp/pc/ai/tokenconfig/currentquota`, {
    method: 'GET',
  });
}

/**
 * 中断生成项
 * @param {Object} params - { itemId }
 */
export async function interruptAiSessionItem(params) {
  return request(`${basePath}/interruptaisessionitem`, {
    method: 'GET',
    params,
  });
}

/**
 * 删除生成项
 * @param {Object} params - { itemId }
 */
export async function deleteAiSessionItem(params) {
  return request(`${basePath}/deleteaisessionitem`, {
    method: 'GET',
    params,
  });
}

/**
 * 获取可用的AI模型列表（接口控制模型是否显示）
 * @returns data 为模型代码数组，如 ['M-0001-0001', 'M-0001-0002']
 */
export async function getAvailableAiModelList(params) {
  return request(`${basePath}/getavailableaimodellist`, {
    method: 'GET',
    params,
  });
}
